/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { Layout } from "antd";
import ProfileUpdateForm from "./ProfileUpdateForm";
function ProfileUpdate() {
  const { Content } = Layout;
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <ProfileUpdateForm />
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default ProfileUpdate;
